import React from 'react';
import {createRoot} from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "app/store";
import JivoChatLoader from "common/hook/useJivoChat";

import {ConfigProvider} from "antd";


import ruRU from "antd/es/locale/ru_RU";

import dayjs from "dayjs";
import "dayjs/locale/ru";

dayjs.locale("ru");


const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <ConfigProvider locale={ruRU}
        theme={{
            token: {
                colorPrimary: '#7ee1a6',
                borderRadius: 2,
                colorBorder: 'transparent',

                colorBgContainer: '#fff',
            },
            components: {
                Select: {
                },
            },
        }}
    >
        <Provider store={store}>
            <BrowserRouter>
                <App/>
                <JivoChatLoader/>
                {/*<MetaPixel />*/}
            </BrowserRouter>
        </Provider>
    </ConfigProvider>
)


serviceWorker.unregister();


export {};